import { Box } from '@mui/material';
import { RisksType, RISK_STATUS, RISK_TYPE } from 'domain/shared/newProject';
import RiskSection from '../../commercial/sections/RiskSection';
import { EMPTY_MESSAGES, SECTION_TITLES } from '../../commercial/constants';
import { ControlData } from '../../types';
import { getOutdatedRisks } from '../../utils';

type StaffingRisksProps = {
  data: ControlData;
};

const StaffingSections = ({ data }: StaffingRisksProps) => {
  const allRisks = data?.risks || [];

  const activeRisks = allRisks.filter(
    (risk: RisksType) => risk.type === RISK_TYPE.STAFFING && risk.status === RISK_STATUS.ACTIVE,
  );

  const escalatedRisks = activeRisks.filter((risk: RisksType) => risk.isEscalated);
  const otherRisks = activeRisks.filter((risk: RisksType) => !risk.isEscalated);
  const outdatedRisks = getOutdatedRisks(activeRisks);

  return (
    <Box sx={{ px: 2, py: 1 }}>
      <RiskSection
        title={SECTION_TITLES.ESCALATED_STAFFING_RISKS}
        risks={escalatedRisks}
        emptyMessage={EMPTY_MESSAGES.ESCALATED_RISKS}
      />
      <RiskSection
        title={SECTION_TITLES.OTHER_STAFFING_RISKS}
        risks={otherRisks}
        emptyMessage={EMPTY_MESSAGES.OTHER_RISKS}
      />
      {outdatedRisks.length > 0 && (
        <RiskSection
          title={SECTION_TITLES.OUTDATED_RISKS}
          risks={outdatedRisks}
          emptyMessage={EMPTY_MESSAGES.OTHER_RISKS}
        />
      )}
    </Box>
  );
};

export default StaffingSections;
